export default __webpack_public_path__ + "static/media/uzeli-logo.4abbdbd8.png";